import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
import type {
  CreateInviteInput,
  CreateInviteOutput,
  RedeemInviteInput,
  RedeemInviteOutput,
  RemoveMemberInput,
  UpdateMemberRoleInput,
  CreateOrganizationInput,
  CreateOrganizationOutput,
  LeaveOrganizationInput,
  UpdateOrganizationNameInput,
  LanguageCode,
} from "./types";

export const createInviteFn = httpsCallable<CreateInviteInput, CreateInviteOutput>(
  functions,
  "createInvite"
);

export const redeemInviteFn = httpsCallable<RedeemInviteInput, RedeemInviteOutput>(
  functions,
  "redeemInvite"
);

export const removeMemberFn = httpsCallable<RemoveMemberInput, { ok: true }>(
  functions,
  "removeMember"
);

export const updateMemberRoleFn = httpsCallable<UpdateMemberRoleInput, { ok: true }>(
  functions,
  "updateMemberRole"
);

export const createOrganizationFn = httpsCallable<
  CreateOrganizationInput,
  CreateOrganizationOutput
>(functions, "createOrganization");

export const leaveOrganizationFn = httpsCallable<LeaveOrganizationInput, { ok: true }>(
  functions,
  "leaveOrganization"
);

export const deleteAccountFn = httpsCallable<Record<string, never>, { ok: true }>(
  functions,
  "deleteAccount"
);

export const updateOrganizationNameFn = httpsCallable<
  UpdateOrganizationNameInput,
  { ok: true }
>(functions, "updateOrganizationName");

export const updateUserLanguageFn = httpsCallable<
  { language: LanguageCode },
  { ok: true }
>(functions, "updateUserLanguage");

